// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "77b44ae-dirty",
    "hash": "77b44ae",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "77b44ae-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
